import React, { ChangeEvent } from 'react'
import { useFilters } from '../../context/FiltersContext'
import { FilterCategoryType } from '../../types'
import { FilterCategory } from './FilterCategory'

export const Filters: React.FC = () => {
  const filtersContext = useFilters()

  if (!filtersContext) return null

  const {
    clearance,
    setClearance,
    clearActiveFilters,
    filters,
  } = filtersContext

  const toggleClearance = (event: ChangeEvent<HTMLInputElement>): void =>
    setClearance(event.target.checked)

  return (
    <div className="refineby ">
      <h4 className="refineby-title" id="FilterTrigger">
        REFINE BY
      </h4>
      <span className="refineby-clear" onClick={clearActiveFilters}>
        Clear All
      </span>
      <div className="refineby-wrap" id="FilterWrap">
        {Object.keys(filters).map((key: FilterCategoryType) => (
          <FilterCategory key={key} category={key} filters={filters[key]} />
        ))}
        <div className="refineby-clearance">
          <label className={clearance ? '__checked' : undefined}>
            <input
              type="checkbox"
              checked={clearance}
              onChange={toggleClearance}
            />
            Clearance
          </label>
        </div>
      </div>
    </div>
  )
}
